export const LISTE_PROJETS = {
  title: 'Liste des projets',
  breadcrumb: {
    listeProjets: 'Liste des projets',
  },
  actions: {
    add: 'Ajouter un projet',
  },
  tabs: {
    libelle: 'Libellé',
    nbrDossier: 'Nombre de dossiers',
    nbrOt: 'Nombre d\'ordres de travail',
    progression: 'Progression',
    archiver: 'Archivé',
  },
  filtre: {
    agences: 'Agence(s)',
    archive: 'Archivé',
  },
  popUpAjoutProjet: {
    title: 'Ajouter un projet',
    libelle: 'Libellé',
    edit: 'Modifier un projet',
  },
  deleteProjet: 'Voulez-vous supprimer le projet ?',
  archivageDesarchiver: {
    archivage: 'Etes-vous sûr de vouloir archiver ce projet ?',
    desarchivage: 'Etes-vous sûr de vouloir désarchiver ce projet ?',
  },
  messages: {
    success: {
      archivage: 'Projet archivé avec succès.',
      desarchivage: 'Projet désarchivé avec succès.',
      deleteProjet: 'Projet supprimé avec succès.',
      createProjet: 'Projet créé avec succès.',
      updateProjet: 'Projet modifié avec succès.',
    },
  },
};

export const EDITION_PROJET = {
  title: 'Projet : {libelle}',
  addFolder: 'Ajouter un dossier',
  addOt: 'Ajouter un ordre de travail',
  noDossier: 'Aucun dossier dans le projet',
  breadcrumb: {
    home: 'Accueil',
    listeProjet: 'Liste des projets',
    projet: 'Projet : {libelle}',
  },
  ligneDossier: {
    nbrOt: '{nbrOt} ordre(s) de travail',
    slider: '{done}/{total}',
    deleteDossier: 'Voulez-vous supprimer le dossier ?',
  },
  ligneOt: {
    planifie: 'Planifié le {date}',
    noPlanifie: 'Pas de date de planification',
    realise: 'Réalisé le {date}',
    noRealisation: 'Pas de date de réalisation',
    slider: '{done}/{total}',
    noOt: 'Pas d\'ordre de travail',
  },
  popUpDossier: {
    title: 'Ajouter un dossier',
    titleEdit: 'Modifier un dossier',
    libelle: 'Libellé',
  },
};
